/**
 * AI Consent helper
 * Stores user's consent for sending data to third-party AI providers
 * (OpenAI, Anthropic) before any AI feature is used.
 * Required by Apple App Review Guideline 2.1 (third-party AI disclosure).
 */
const CONSENT_KEY = 'ai_provider_consent_v1';

export const hasAIConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY) === 'granted';
  } catch {
    return false;
  }
};

export const grantAIConsent = () => {
  try {
    localStorage.setItem(CONSENT_KEY, 'granted');
    localStorage.setItem(CONSENT_KEY + '_at', new Date().toISOString());
  } catch {}
};

export const revokeAIConsent = () => {
  try {
    localStorage.removeItem(CONSENT_KEY);
    localStorage.removeItem(CONSENT_KEY + '_at');
  } catch {}
};

export const getAIConsentDate = () => {
  try {
    return localStorage.getItem(CONSENT_KEY + '_at');
  } catch {
    return null;
  }
};
